import React, { useEffect } from "react";
import {
  CLIENTEDOCUMENTOS,
  TIPOCLIENTEDOCUMENTOS,
} from "../../../../util/typesReactQuery";
import { useQuery, useInfiniteQuery } from "react-query";
import { Grid, Skeleton, Box, Typography } from "@mui/material";
import { useAuth } from "../../../../hooks/AuthContext";
import DocumentoController from "../../../../components/EdicaoCadastro/Documentos";
import {
  getDocumentosCliente,
  getTiposDocumentoByIDCliente,
} from "../../../../api/chamadasApi";
import Button from "@mui/material/Button";
import ButtonVoltar from "../../../../components/Botoes/ButtonVoltar";
import useAlert from "../../../../hooks/useAlert";
import useStyles from "./styles";
import { Titulo } from "../../../../components";

export default function Documento({ handlerCancelEdit }) {
  const { user } = useAuth();
  const { showAlertError } = useAlert();
  const classes = useStyles();

  const {
    isLoading: isLoadingDocumento,
    refetch: refetchDocumentos,
    data: dataDocumento,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    [CLIENTEDOCUMENTOS],
    ({ pageParam = 1 }) => getDocumentosCliente(user.id, pageParam),
    {
      getNextPageParam: (lastPage, allPages, data) => {
        if (lastPage.data.length === 5) {
          return allPages.length + 1;
        }
        return undefined;
      },
      onError: (error) => {
        console.error("error", error);
        showAlertError(
          `Ops, algo deu errado: ${error.message ?? error} - R102S`
        );
      },
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  const { data: dataTipoDocumento, isLoading: isLoadingTipoDocumento } =
    useQuery(
      [TIPOCLIENTEDOCUMENTOS],
      () => getTiposDocumentoByIDCliente(user.id),
      {
        refetchOnWindowFocus: false,
        retry: false,
        onSuccess: (dataTipoDocumento) => {},
        onError: (error) => {},
      }
    );

  useEffect(() => {
    refetchDocumentos();
  }, []);

  // Verifica se existem documentos
  const hasDocuments = dataDocumento?.pages?.[0]?.data?.length > 0;

  return (
    <Box className={classes.root}>
      <Grid container className={classes.container}>
        {/* Cabeçalho */}
        <Grid item xs={12} className={classes.header}>
          <Box display="flex" alignItems="center" mb={2}>
            <ButtonVoltar handleVoltar={handlerCancelEdit} mostraTexto={true} />
          </Box>
          <Titulo variant="h5" className={classes.title}>
            Meus documentos
          </Titulo>
        </Grid>

        {/* Conteúdo principal */}
        <Grid item xs={12}>
          <DocumentoController
            documentos={
              dataDocumento !== undefined ? dataDocumento?.pages : null
            }
            tiposDocumento={dataTipoDocumento}
            loading={isLoadingDocumento || isLoadingTipoDocumento}
            userID={user.id}
          />
        </Grid>
        {/* {!isLoadingDocumento && !hasDocuments && (
          <Typography
            variant="body1"
            color="textSecondary"
            className={classes.emptyState}
          >
            Você ainda não possui documentos cadastrados.
          </Typography>
        )} */}
        {/* Botão carregar mais */}
        {hasDocuments && hasNextPage && (
          <Grid item xs={12} className={classes.loadMoreContainer}>
            {!isFetchingNextPage ? (
              <Button
                size="medium"
                onClick={fetchNextPage}
                variant="outlined"
                className={classes.loadMoreButton}
                fullWidth
              >
                Carregar mais documentos
              </Button>
            ) : (
              <Box display="flex" justifyContent="center" width="100%">
                <Skeleton width={200} height={40} animation="wave" />
              </Box>
            )}
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
